import { Package } from "../../subscriptions/modules/packages/models/Package";
import { PackageGroupResponse } from "./PackageGroupResponse";

export class PackageGroup {
  /**
   * @param {String} id
   * @param {String} name
   * @param {Package[]} packages
   */
  constructor(id, name, packages,isAffectApp, deletedAt) {
    this.id = id;
    this.name = name;
    this.packages = packages;
    this.isAffectApp = isAffectApp
    this.deletedAt= deletedAt
  }

  /**
   * @param {PackageGroupResponse} response
   *
   * @return {PackageGroup}
   */
  static createFromResponse(response) {
    const { id, name, packages: packageResponses, isAffectApp, deletedAt } = response;
    const packages = packageResponses.map(packageResponse =>
      Package.createFromResponse(packageResponse)
    );
    return new PackageGroup(id, name, packages,isAffectApp,deletedAt);
  }
}



// WEBPACK FOOTER //
// ./src/features/group/models/PackageGroup.js